<script lang="ts">
  import {
    Button,
    Column,
    ContentSwitcher,
    Grid,
    Row,
    Switch,
  } from "carbon-components-svelte";
  import type { IImage } from "src/ts/Interfaces";
  import PresetPostions from "./PresetPostions.svelte";
  import PositionPlacement from "./PositionPlacement.svelte";
  import { TrashCan } from "carbon-icons-svelte";
  import type APIClient from "src/ts/APIClient";
  import Slider from "./Slider.svelte";

  export let client: APIClient;
  export let image: IImage;

  let thumbnailPromise: Promise<string>;

  let selectedIndex = image.usePositionPreset ? 0 : 1;

  function updateSize(value) {
    image.placement.widthInPercentage = image.placement.heightInPercentage =
      value;
    return image;
  }

  function updatePositioningMethod(selectedIndex) {
    image.usePositionPreset = selectedIndex == 0;
    return image;
  }

  thumbnailPromise = client.fetchThumbnail(image.imageId);

  $: image = updatePositioningMethod(selectedIndex);
</script>

<Grid noGutter class="pane">
  <Row>
    <Column sm={16} md={6} lg={12}>
      {#await thumbnailPromise then base64image}
        <img alt="thumbnail" src={base64image} height="50px" />
      {/await}
    </Column>
    <Column sm={16} md={2} lg={4}>
      <Button kind="danger-tertiary" size="small" on:click icon={TrashCan}>
        Remove Image
      </Button>
    </Column>
  </Row>
  <Row>
    <Column>
      <Slider
        labelText="Size (%)"
        min={0}
        max={100}
        step={1}
        value={50}
        on:change={(e) => {
          image = updateSize(e.detail);
        }}
      />
    </Column>
    <Column>
      <ContentSwitcher bind:selectedIndex>
        <Switch text="Preset Positions" />
        <Switch text="Place Manually" />
      </ContentSwitcher>
      <div class="pane">
        {#if selectedIndex == 0}
          <PresetPostions
            id={image.imageId}
            bind:positionPreset={image.positionPreset}
          />
        {:else}
          <PositionPlacement bind:placement={image.placement} />
        {/if}
      </div>
    </Column>
  </Row>
</Grid>
